/**
 * This will be use on gap styling
 */
const spacing = {
    100: '4px',
    200: '8px',
    300: '12px',
    400: '16px',
    500: '20px',
    600: '24px',
    700: '32px',
    800: '36px',
    900: '48px',
}

export default spacing
export type Spacing = typeof spacing
